import { render, staticRenderFns } from "./OfferBlock.vue?vue&type=template&id=7d192d18&scoped=true&"
import script from "./OfferBlock.vue?vue&type=script&lang=js&"
export * from "./OfferBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d192d18",
  null
  
)

export default component.exports